import { useParams } from 'react-router-dom';

import { HubDetail } from './HubDetail';
import { usePractise } from './usePractise';

/**
 * The deep-link entry point for `/practice/:itemId`.
 *
 * Thin on purpose. It used to query the item and then render `HubDetail`,
 * which queried the same item again — two round trips and two sources of truth
 * about whether the item exists. `HubDetail` owns that query; this owns the
 * route and the action.
 */
export function PracticeItemDetail() {
  const { itemId = '' } = useParams<{ itemId: string }>();
  const { practise, busy, why } = usePractise();

  return (
    <div className="flex flex-col gap-4 py-6">
      <HubDetail itemId={itemId} onPractise={(id) => practise({ practiceItemId: id })} busy={busy} why={why} />
    </div>
  );
}
